import { Gallery } from './components/Gallery.js';

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', async () => {
  console.log('Initializing Gallery Maze...');

  // Get canvas element
  const canvas = document.getElementById('gallery-canvas');

  if (!canvas) {
    console.error('Canvas element not found!');
    return;
  }

  // Create gallery instance
  const gallery = new Gallery(canvas);

  // Initialize gallery (start is handled by UI start button)
  try {
    await gallery.init();
    console.log('Gallery initialized - waiting for user to start');
  } catch (error) {
    console.error('Failed to initialize gallery:', error);
    const loadingText = document.getElementById('loading-text');
    if (loadingText) {
      loadingText.textContent = 'Error loading gallery. Please refresh the page.';
    }
  }

  // Handle page visibility changes (pause when tab is not visible)
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      console.log('Page hidden - gallery continues running');
    } else {
      console.log('Page visible');
    }
  });

  // Cleanup on page unload
  window.addEventListener('beforeunload', () => {
    gallery.dispose();
  });
});

// Handle errors
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});
